export const heroAE = {
  image: 'https://kia-afonso-storage.b-cdn.net/Anpassningar/_smh9499.jpg',
  altText:
    'En vit och svart Kia PV5 Cargo-skåpbil med öppen sidodörr och lastutrymme med hyllor, parkerad på grus framför ett trähus.',
  title: 'Nya Kia PV5 Cargo.',
  subtitle: 'Byggd för dig.',
  position: 'bottom' as const,
  hAlign: 'left' as const,
  titleClass: 'text-[clamp(38px,8vw,64px)] font-[400]',
  subtitleClass: 'text-[clamp(14px,5vw,24px)] font-[300]',
};

export const textAE001 =
  'Nya Kia PV5 Cargo har oändliga möjligheter att anpassas efter era behov. Vi hjälper er att skräddarsy transportbilen med de lösningar som krävs för er verksamhet och specifika krav. Det kan gälla allt ifrån dragkrok, varningsljus, specialbelysning, hyllsystem, säker verktygsförvaring till komplett inredning.';

export const smallAEImg001 = {
  src: 'https://kia-afonso-storage.b-cdn.net/Anpassningar/_SMH9231.jpg',
  alt: 'En närbild på en person som bär arbetshandskar och drar ut en grå metallåda från ett modulärt hyllsystem monterat i en skåpbil.',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full h-full object-cover',
};

export const smallAEImg002 = {
  src: 'https://kia-afonso-storage.b-cdn.net/Anpassningar/_SMH9257.jpg',
  alt: 'En närbild inuti en skåpbil som visar ett grått hyllsystem. En person drar ut en svart och grön verktygslåda/sortimentslåda, märkt med text som "SYSTEM EDSTRÖM", med små fack. Andra svarta förvaringslådor och gröna plastfack samt verktyg syns i hyllorna.',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full h-full object-cover',
};

export const textAE002 =
  'En rullande verkstad och en arbetsplats som ständigt är i rörelse ställer krav på utrustning och inredning. Det kräver specialkunskap. Våra partners är experter på inredning och specialanpassning av fordon. Det innebär att ni t.ex kan lita på att er transportbil har säkra hyllsystem, lådor och utrustning av hög kvalitet som klarar tuffa tag och är optimerade för ett arbetsliv i rörelse.';

export const textAE003 =
  'Kontakta din återförsäljare så optimerar ni tillsammans Kia PV5 Cargo efter just era behov. Vi ser sedan till att bilen levereras komplett och är redo att börja jobba från dag ett.';

export const linkAE01 = {
  text: 'Hitta din återförsäljare',
  textSize: '16px',
  url: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
  className:
    'mt-6 mb-6 text-center ml-0 sm:ml-2 self-center sm:self-start md:self-end',
  widthClass: 'w-fit px-4 ',
  openInNewTab: false,
};

export const textAE004 = 'Läs mer om våra partners';

export const textAE005 = 'Specialanpassning:';

export const linkAE02: { label: string; href: string; target: string } = {
  label: 'Bilbyggarna i Wallhamn',
  href: 'https://www.wallhamn.com/om-bilbyggarna',
  target: '_blank',
};
export const textAE006 = 'Serviceinredning:';

export const linkAE03: { label: string; href: string; target: string } = {
  label: 'System Edström',
  href: 'https://www.systemedstrom.com/sv/',
  target: '_blank',
};
